export interface HydraCollection<T = unknown> {
  member?: T[]
  'hydra:member'?: T[]
  totalItems?: number
  'hydra:totalItems'?: number
}

// Default T = any erhält die bisherige Typ-Inferenz der endpoints.ts-Funktionen,
// deren Rückgabetyp vor der Extraktion implizit any[] war.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function extractMembers<T = any>(data: unknown): T[] {
  if (!data || typeof data !== 'object') return []
  const collection = data as HydraCollection<T>
  const members = collection.member ?? collection['hydra:member']
  return Array.isArray(members) ? members : []
}

export function extractTotalItems(data: unknown): number {
  if (!data || typeof data !== 'object') return 0
  const collection = data as HydraCollection
  const total = collection.totalItems ?? collection['hydra:totalItems']
  if (typeof total === 'number') return total
  return extractMembers(data).length
}

export function extractIdFromIri(value: unknown): number | null {
  if (typeof value === 'number' && Number.isInteger(value)) return value

  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>
    if (typeof record.id === 'number' && Number.isInteger(record.id)) return record.id

    const iri = typeof record['@id'] === 'string' ? record['@id'] : ''
    const match = iri.match(/\/(\d+)$/)
    if (match) return Number(match[1])
  }

  if (typeof value === 'string') {
    const match = value.match(/\/(\d+)$/)
    if (match) return Number(match[1])
  }

  return null
}
